import axios from "axios";
import { loaderStore } from "./lodaerStore";

function getHeaders() {
  return { "Content-Type": "application/json" };
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: getHeaders(),
});

// Routes/endpoints where the global loader should NOT show.
// Matches if the request url INCLUDES any of these strings.
const EXCLUDED_LOADER_URLS = [
  "/notifications/poll",
  "/heartbeat",
  "/live-scores",
  "/match-odds",
];

function shouldSkipLoader(config) {
  // 1. explicit per-call override: apiGet(url, params, { skipLoader: true })
  if (config?.skipLoader) return true;

  // 2. matches an excluded route
  const url = config?.url || "";
  return EXCLUDED_LOADER_URLS.some((excluded) => url.includes(excluded));
}

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }

  config._skipLoader = shouldSkipLoader(config);
  if (!config._skipLoader) {
    loaderStore.start();
  }

  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (!response.config?._skipLoader) {
      loaderStore.stop();
    }
    return response;
  },
  (error) => {
    if (!error.config?._skipLoader) {
      loaderStore.stop();
    }

    const status = error.response?.status;

    if (status === 401 || status === 403) {
      console.log(`error ${status}`);
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("uniqueId");
      window.location.reload();
    } else if (!error.response) {
      console.log("network error", error.message);
    }

    return Promise.reject(error);
  },
);

function apiGet(url, params = {}, config = {}) {
  return instance.get(url, { params, ...config });
}

function apiPost(url, body, config = {}) {
  return instance.post(url, body, config);
}

function apiPut(url, body, config = {}) {
  return instance.put(url, body, config);
}

function apiDelete(url, config = {}) {
  return instance.delete(url, config);
}

export { getHeaders, apiGet, apiPost, apiPut, apiDelete };
